<template>
  <div class="album py-5 bg-light h-100">
    <div class="container">
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <farm-card
          v-for="(entry, index) in farmsSorted"
          :key="index"
          :name="entry[1].name"
          :id="entry[0]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import FarmCard from "@/components/FarmCard.vue";

export default {
  components: { FarmCard },

  setup() {
    const store = useStore();

    const farmsSorted = computed(() => {
      const farms = store.getters.farms ?? {};

      return Object.entries(farms).sort((a, b) =>
        a[1].name.localeCompare(b[1].name, undefined, { sensitivity: "base" })
      );
    });

    return { farmsSorted };
  },
};
</script>

<style></style>
